import { swalWithButtonsW } from "./swal";

export default () => {
  const form_contact = document.querySelector("#contact-form")
  if (form_contact) {
    form_contact.addEventListener("ajax:send", () => {
      swalWithButtonsW.fire({
        title: 'Enviando email',
        text: "Por favor espere mientras se completa el envio del formulario.",
        timerProgressBar: true,
        showConfirmButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false
      })
    })

    form_contact.addEventListener("ajax:success", () => {
      swalWithButtonsW.fire({
        title: '¡Exito!',
        icon: "success",
        text: "Se ha enviado la solicitud correctamente.",
      })
    })

    form_contact.addEventListener("ajax:error", () => {
      swalWithButtonsW.fire({
        title: 'Error',
        icon: "error",
        text: "Ha ocurrido un problema, intentelo mas tarde.",
      })
    })
  }
}